/** Feature flags for grading UX experiments (persisted `dg_elite_flags_v1`). */
export type EliteFeatureFlags = {
  cameraFirstLaunch: boolean;
  swipeQuickMatch: boolean;
  autoAdvanceAfterConfirm: boolean;
  publishReadinessMeter: boolean;
  auditBulkActions: boolean;
  feedbackTemplates: boolean;
  errorRecoveryCard: boolean;
  hapticsAudio: boolean;
  sessionSnapshot: boolean;
  qualityGuardrailMode: boolean;
};

export type EliteMetricsStore = {
  eventCounts: Record<string, number>;
  lastEventAt: number | null;
};

export const ELITE_FLAGS_KEY = 'dg_elite_flags_v1';
export const ELITE_METRICS_KEY = 'dg_elite_metrics_v1';

export const ELITE_FLAGS_DEFAULTS: EliteFeatureFlags = {
  cameraFirstLaunch: true,
  swipeQuickMatch: true,
  autoAdvanceAfterConfirm: true,
  publishReadinessMeter: true,
  auditBulkActions: true,
  feedbackTemplates: true,
  errorRecoveryCard: true,
  hapticsAudio: false,
  sessionSnapshot: true,
  qualityGuardrailMode: false,
};
